/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * flow metadata for initFlow
 */
export interface InitMetadata {
  date?: string;
  browser?: string;
  locale?: string;
  time?: string;
}
